import SalesOverview from './SalesOverview';

export default (props) => <SalesOverview {...props} />;
